import { render } from "./LogoSemtax.vue?vue&type=template&id=595b8e18"
const script = {}

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__